import { isLocalBzDomain, isProductionBzDomain, isSandboxBzDomain, isStagingBzDomain } from './domain';
import { runningServerSide } from './running';

export const getRuntimeEnvironment = () => {
  if (runningServerSide()) {
    return process.env.RUNTIME_ENV;
  } else {
    if (isStagingBzDomain()) return 'staging';
    if (isSandboxBzDomain()) return 'sandbox';
    if (isLocalBzDomain()) return 'development';
    if (isProductionBzDomain()) return 'production';
    return 'production';
  }
};
